export const SUCCESS = "SUCCESS"
export const FAILURE = "FAILURE"
export const ERROR = "ERROR"
export const UPDATE_QUANTITY = "UPDATE_QUANTITY"
export const MARK_APPROVED = "MARK_APPROVED"
export const MARK_MISSING = "MARK_MISSING"
export const MARK_MISSING_URGENT = "MARK_MISSING_URGENT"
export const FINAL_APPROVAL = "FINAL_APPROVAL"
//----optional 
export const HIGHLIGHT_REASON = "HIGHLIGHT_REASON";
